import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { launcherLaunchEve } from '../../launcherBackend/launcher-command'
import attributes from '../../settings/references.json'
import styles from './launch-frame.scss'

class LaunchFrame extends Component {
    componentDidMount() {
        this.props.setClientLaunchProgress(1)
    }

    onLoad = (event) => {
        try {
            if (this.props.progress === 1) {
                this.props.setClientLaunchProgress(10)
            } else {
                this.props.setClientLaunchProgress(80)
            }
            let tokenExpired = false

            // Define regex rules
            const regexRules = {
                // Launch token is detected
                '#access_token=([^&]+)&token_type=Client': (matches) => {
                    this.props.setClientLaunchProgress(100)
                    launcherLaunchEve(
                        this.props.server.shortName,
                        this.props.user.username,
                        this.props.user.profile,
                        matches[1], // Retrieve the token from the url
                    )
                },

                // Token expired URL detected
                'launcher([^#]+)#error=invalid_token&error_description=expired': () => {
                    console.info(
                        `Token for ${this.props.user
                            .username} is invalid or expired, attempting refresh`,
                    )

                    if (this.props.progress <= 10) {
                        this.props.setClientLaunchProgress(50)
                    }
                    tokenExpired = true
                },

                'token?accesstoken=': () => {
                    console.warn('Expected launch token, but received no change')
                    this.props.setClientLaunchProgress(0)
                },
            }

            try {
                // Get the current URL of the iframe
                const url = event.currentTarget.contentWindow.location.href

                // Parse through each regex rule
                _.forOwn(regexRules, (func, regex) => {
                    const matches = new RegExp(regex, 'i').exec(url)
                    if (matches && typeof func === 'function') {
                        func(matches)
                    }
                })
            } catch (error) {
                // TODO: Remove once SSO has fixed the document.domain issue.
                if (error.message.indexOf('Blocked a frame with origin') !== -1) {
                    tokenExpired = true
                    console.info(
                        'Received blocked origin for launch token, retrying with refresh token.',
                    )
                } else {
                    console.error(`Error occurred while running regex rules: ${error.message}`)
                    this.props.setClientLaunchProgress(0)
                }
            }

            // Remove the iframe since it's no longer useful
            if (tokenExpired) {
                this.props.onTokenExpired()
            } else {
                this.props.unMount()
            }
        } catch (error) {
            console.info(
                `Error occurred while launching client for ${this.props.user
                    .username}: ${error.message}`,
            )
            this.props.setClientLaunchProgress(0)
        }
    }

    render() {
        // Retrieve the hostname from the server object
        const host = this.props.server.sso.url

        // Retrieve the access token from the user object
        const accessToken = this.props.user.tokens.accessToken

        // Prepare the SSO link
        const source = attributes.service.sso.clientToken
            .replace('{host}', host)
            .replace('{accessToken}', accessToken)

        // Add a unique class to the iframe
        const className = `${styles.launchFrame} ${accessToken}`

        return (
            <iframe
                onLoad={event => this.onLoad(event)}
                title={accessToken}
                className={className}
                src={source}
                width={0}
                height={0}
            />
        )
    }
}

LaunchFrame.propTypes = {
    server: PropTypes.shape({
        shortName: PropTypes.string,
        sso: PropTypes.shape({
            slinger: PropTypes.string,
            url: PropTypes.string,
        }),
    }),
    user: PropTypes.shape({
        profile: PropTypes.string,
        tokens: PropTypes.shape({
            accessToken: PropTypes.string,
            refreshToken: PropTypes.string,
        }),
        username: PropTypes.string,
    }),
    unMount: PropTypes.func,
    onTokenExpired: PropTypes.func,
    setClientLaunchProgress: PropTypes.func,
    progress: PropTypes.number,
}

export default LaunchFrame



// WEBPACK FOOTER //
// ./src/components/LaunchFrame/launch-frame.js